module.exports = __webpack_public_path__ + "static/img/3.47f4868.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/register/ovulation/3.png
// module id = OA5J
// module chunks = 1